<div class="onboarding-main-wrap p-3 p-md-5">
    <div class="row onboarding-step-count-wrap">
        <div class="col-1 d-none d-md-block"></div>
        <div class="col-12 col-md-11 col-lg-6">
            <p class="font-semibold text-uppercase step-count-wrap mb-0">Step 3</p>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-1 d-none d-md-block">
            <div class="col-1">
                <div class="steps position-absolute">
                    <div class="step">
                        <div class="step-number-wrapper">
                            <div class="step-number">1</div>
                        </div>
                    </div>
                    <div class="step">
                        <div class="step-number-wrapper step-two">
                            <div class="step-number">2</div>
                        </div>
                    </div>
                    <div class="step">
                        <div class="step-number-wrapper step-three">
                            <div class="step-number">3</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-11 col-lg-6">
            <h2 class="font-poppins card-header-wrap">Enter your Card details to Start.</h2>
        </div>
    </div>

    <div class="row mb-5 onboarding-content-wrap">
        <div class="col-1 d-none d-md-block"></div>
        <div class="col-12 col-md-11 col-lg-6 order-2 order-sm-2 order-md-2 order-lg-1 mb-lg-0 mb-md-4 mb-sm-4 mb-4">
            <div class="stripe-container">
                <div id="card-element">
                </div>
                <div id="card-errors" class="mt-4 mb-2 text-danger font-poppins" role="alert"></div>
                <div id="progress" style="display:none; height: 20px;">
                    <div class="d-flex justify-content-center">
                        <div class="lds-ellipsis-container mt-0">
                            <div class="lds-ellipsis">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <mat-card class="mat-elevation-z0 w-100 add-blue-card p-3 d-inline-block font-medium mt-4">
                No charges will apply for the first 30 days upon connecting with Key Automate. After this period,
                regular charges will commence.
            </mat-card>
        </div>

        <div class="col-12 col-md-11 col-lg-5 order-1 order-sm-1 order-md-1 order-lg-2 mb-lg-0 mb-md-4 mb-sm-4 mb-4">
            <div class="d-flex justify-content-center align-items-center onboarding-img-wrap">
                <img src="../../../../assets/images/onboarding-step-3.svg" alt="">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-1 d-none d-md-block"></div>
        <div class="col-9 mb-4 terms-container">
            <mat-checkbox (change)="select($event.checked)">
                <span class="font-14 font-medium ms-1">I have read and agree to the <a
                        href="https://www.proptechlabs.com/privacy" target="_blank">Privacy
                        policy</a> and <a href="https://www.proptechlabs.com/terms-and-conditions" target="_blank">Terms
                        &
                        conditions</a></span>
            </mat-checkbox>
        </div>
    </div>
    <div class="row">
        <div class="col-1 d-none d-md-block"></div>
        <div class="col-5 col-md-5 col-lg-5">
            <div class="d-flex button-wrap">
                <button class="common-button light-gray mat-elevation-z0 me-3" mat-button mat-raised-button
                    (click)="back() " [disabled]=" isCardAdding">Back</button>
                <button class="common-button blue mat-elevation-z0 me-3" mat-button mat-raised-button (click)="next()"
                    [disabled]="!canFinishOnboarding || hasError || isCardAdding">Finish</button>
            </div>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
            <a [href]="maintenanceAppUrl"
                class="blue mat-elevation-z0 me-3 d-flex justify-content-end align-items-center exit-onboard">
                <mat-icon class="material-icons-outlined me-1" mat-list-icon>exit_to_app</mat-icon> Exit Onboarding
            </a>
        </div>
    </div>
</div>